export default function (store, config) {
    store.setState({
        edit: config,
    });
}
//# sourceMappingURL=edit.js.map